export const graphColors = [
    "#EF9B20",
    // "#EDBF33",
    // "#EDE15B",
    // "#BDCF32",
    "#87BC45",
    "#27AEEF",
    "#B33DC6",
    "#77D69F",
    "#FFAB73",
    "#FF9C97",
    "#EA5545",
    "#F46A9B",
    "#A084CA",
    "#7EC4CF",
    "#77D69F",
];

export const pieColors = [
    "#7950f2", // violet-6
    "#12b886", // teal-6
    "#FAB005", // yellow-6
    "#228BE6", // blue-6
    "#BE4BDB", // grape-6
    "#74B816", // lime-7
    "#E64980", // pink-6
    "#2F9E44", // green-8
    "#4DABF7", // blue-4
    "#38D9A9", // teal-4
    "#FD7E14", // orange-6
];
